export default "__VITE_ASSET__CQFALbE5__"